<template>
  <v-container class="ma-0 pa-0 mw-100">
    <header-big :title="$t('HomePage.header.admin')" />

    <v-row class="pb-5 pt-5">
      <v-col class="text-left">
        <v-btn-toggle
          tile
          :color="color"
          group
          mandatory
          v-model="selectedToggleButton"
        >
          <toggle-button
            icon="mdi-view-dashboard"
            :tooltip="$t('AdminPage.Token_Table_Header')"
            @click="showTokens"
          />
          <toggle-button
            icon="mdi-account-circle"
            :tooltip="$t('AdminPage.User_Table_Header')"
            @click="showUsers"
          />
          <toggle-button
            icon="mdi-account-edit"
            :tooltip="$t('AdminPage.ChangeUserData')"
            @click="showAccount"
          />
          <toggle-button
            icon="mdi-home-variant"
            :tooltip="$t('AdminPage.ChangeOrgaData')"
            @click="showOrganisation"
          />
          <toggle-button
            icon="mdi-pencil-ruler"
            :tooltip="$t('AdminPage.Whitelabeling')"
            @click="showWhitelabeling"
          />
          <toggle-button
            icon="mdi-server"
            :tooltip="$t('AdminPage.Api.shortHeader')"
            @click="showAPI"
          />
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card
      class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10"
    >
      <v-container pa-0>
        <v-card-text>
          <v-sheet min-height="70vh" rounded="lg">
            <header-small
              :text="$t('AdminPage.Header') + ' ' + license.organization_name"
            />
            <p
              v-text="$t('AdminPage.Licensekey') + ': ' + license.license_id"
            />

            <v-row justify="center">
              <v-col cols="12" sm="12" v-if="viewTokens">
                <p class="d-none">{{ (selectedToggleButton = 0) }}</p>
                <tokens :items="tokens" :license="license" />
              </v-col>
              <v-col cols="12" sm="12" v-if="viewUsers">
                <p class="d-none">{{ (selectedToggleButton = 1) }}</p>
                <user :items="users" />
              </v-col>
              <v-col cols="12" sm="12" v-if="viewAccount">
                <p class="d-none">{{ (selectedToggleButton = 2) }}</p>
                <account />
              </v-col>
              <v-col cols="12" sm="12" v-if="viewOrganisation">
                <p class="d-none">{{ (selectedToggleButton = 3) }}</p>
                <organization />
              </v-col>
              <v-col cols="12" sm="12" v-if="viewWhitelabeling">
                <p class="d-none">{{ (selectedToggleButton = 4) }}</p>
                <whitelabeling />
              </v-col>
              <v-col cols="12" sm="12" v-if="viewAPI">
                <p class="d-none">{{ (selectedToggleButton = 5) }}</p>
                <api />
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import HeaderSmall from "../../components/ui/text/HeaderSmall.vue";
import HeaderBig from "../../components/ui/text/HeaderBig.vue";
import ToggleButton from "../../components/ui/input/ToggleButton.vue";
import Tokens from "../../pages/AdminPage/Tokens.vue";
import User from "../../pages/AdminPage/Users.vue";
import Whitelabeling from "../../pages/AdminPage/Whitelabeling.vue";
import Account from "../../pages/AdminPage/Account.vue";
import Organization from "./Organization.vue";
import Api from "./ApiPage.vue"
import { log } from "@/helpers/logger";

export default {
  name: "Admin",
  components: {
    HeaderSmall,
    HeaderBig,
    ToggleButton,
    Tokens,
    User,
    Whitelabeling,
    Account,
    Organization,
    Api,
  },
  data() {
    return {
      license: "",
      tokens: [],
      users: [],
      selectedToggleButton: null,
      viewTokens: false,
      viewUsers: false,
      viewWhitelabeling: false,
      viewAccount: false,
      viewOrganisation: false,
      viewAPI: false,
      color: null,
    };
  },
  created() {
    this.getData();
    this.color = this.$vuetify.theme.themes.light.primary;
  },
  methods: {
    getData() {
      this.$store
        .dispatch("data/getAccountInformations", this.$store.state.auth.user.id)
        .then((res) => {
          log(
            "AdminPage.index.getData() - get Account Informations for " +
              this.$store.state.auth.user.id,
            "info"
          );
          this.license = res;
          this.tokens = res.tokens;
          this.users = res.users;
          this.tokens.forEach((token) => {
            token.created_at = this.formatDate(token.created_at);
            token.expires_at = this.formatDate(token.expires_at);
          });
          this.users.forEach((user) => {
            user.account_role_text = this.$t(
              "TableContent." + user.account_role
            );
          });
          this.showTokens();
        })
        .catch((err) => {
          log("AdminPage.index.getData() - " + err, "error");
        });
    },
    formatDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
    showTokens() {
      this.$store.commit("set_loading", true);
      this.viewTokens = true;
      this.viewUsers = false;
      this.viewWhitelabeling = false;
      this.viewAccount = false;
      this.viewOrganisation = false;
      this.viewAPI = false;
    },
    showUsers() {
      this.$store.commit("set_loading", true);
      this.viewTokens = false;
      this.viewUsers = true;
      this.viewWhitelabeling = false;
      this.viewAccount = false;
      this.viewOrganisation = false;
      this.viewAPI = false;
    },
    showWhitelabeling() {
      this.$store.commit("set_loading", true);
      this.viewTokens = false;
      this.viewUsers = false;
      this.viewWhitelabeling = true;
      this.viewAccount = false;
      this.viewOrganisation = false;
      this.viewAPI = false;
    },
    showAccount() {
      this.$store.commit("set_loading", true);
      this.viewTokens = false;
      this.viewUsers = false;
      this.viewWhitelabeling = false;
      this.viewAccount = true;
      this.viewOrganisation = false;
      this.viewAPI = false;
    },
    showOrganisation() {
      this.$store.commit("set_loading", true);
      this.viewTokens = false;
      this.viewUsers = false;
      this.viewWhitelabeling = false;
      this.viewAccount = false;
      this.viewOrganisation = true;
      this.viewAPI = false;
    },
    showAPI() {
      this.$store.commit("set_loading", true);
      this.viewTokens = false;
      this.viewUsers = false;
      this.viewWhitelabeling = false;
      this.viewAccount = false;
      this.viewOrganisation = false;
      this.viewAPI = true;
    },
  },
};
</script>

<style scoped>
@media screen {
  .container {
    max-width: 100%;
  }
}
</style>
